import * as firebase from "firebase/app"
import "firebase/auth"
import "firebase/database"

firebase.initializeApp(
  Object.freeze({
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MESUREMENT_ID,
  }),
)
const db = firebase.database
const auth = firebase.auth

let fbDatabaseRef: firebase.database.Reference | null

const fbConnect = (): firebase.database.Reference => {
  fbDatabaseRef = db().ref(".info/connected")
  return fbDatabaseRef
}

const fbDisConnect = (): void => {
  if (!fbDatabaseRef) return

  fbDatabaseRef.off("value")
  fbDatabaseRef = null
}

auth().setPersistence(firebase.auth.Auth.Persistence.NONE)

function getRef(ref: FirebaseRef) {
  return db().ref(ref)
}

const BACKGROUND_TIMEER = 1000 * 60 * 59

let intervalId: NodeJS.Timeout | undefined
;(window as any).document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    if (intervalId) {
      window.clearTimeout(intervalId)
      intervalId = undefined
    }
    db().goOnline()
  } else {
    auth().currentUser?.getIdToken(true)

    intervalId = setInterval(async () => {
      await auth().currentUser?.getIdToken(true)
    }, BACKGROUND_TIMEER)
  }
})

export { db, auth, fbConnect, fbDisConnect, getRef }

export type FirebaseRef =
  | "messages"
  | "private_messages"
  | "schedules"
  | "viewers"
  | "viewer_devices"
  | "daily_users"
  | "stock_counsels"
  | "blind_messages"
  | "blacklist_chats"
  | "partner_messages"
